import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.prototype4');
import { OnInit, ViewChild, ElementRef, OnDestroy } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-prototype4',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.prototype4/view.scss */
:host {
  display: block;
  height: 100%;
}

button {
  transition: background-color 120ms ease, color 120ms ease, border-color 120ms ease;
}

table {
  border-collapse: collapse;
}`],
})
export class PagePrototype4Component implements OnInit, OnDestroy {
    @ViewChild('videoElement') videoElement: ElementRef<HTMLVideoElement>;
    @ViewChild('canvasElement') canvasElement: ElementRef<HTMLCanvasElement>;

    public isCameraOn: boolean = false;
    public analysisRate: number = 3;
    public faces: any[] = [];
    public faceCount: number = 0;
    public inferMs: number = 0;
    public meta: any = null;
    public statusMessage: string = "웹캠을 시작하세요.";
    public trackMemory: any[] = [];
    public eventLog: any[] = [];
    public isExperimentPopupOpen: boolean = false;

    private stream: MediaStream | null = null;
    private captureInterval: any = null;
    private lastLogKey: string = "";

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.service.render();
    }

    public async ngOnDestroy() {
        this.stopCamera();
    }

    public async startCamera() {
        try {
            this.stream = await navigator.mediaDevices.getUserMedia({ video: true, audio: false });
            this.videoElement.nativeElement.srcObject = this.stream;
            this.isCameraOn = true;
            this.statusMessage = "분석 준비 중";

            this.videoElement.nativeElement.onloadedmetadata = () => {
                this.syncCanvasSize();
                this.startAnalysis();
            };

            await this.service.render();
        } catch (err) {
            console.error(err);
            await this.service.alert.show({ title: '오류', message: '카메라 접근 실패' });
        }
    }

    public async stopCamera() {
        if (this.stream) {
            this.stream.getTracks().forEach(track => track.stop());
            this.stream = null;
        }
        if (this.captureInterval) {
            clearInterval(this.captureInterval);
            this.captureInterval = null;
        }
        if (this.videoElement) this.videoElement.nativeElement.srcObject = null;
        if (this.canvasElement) {
            const ctx = this.canvasElement.nativeElement.getContext('2d');
            if (ctx) ctx.clearRect(0, 0, this.canvasElement.nativeElement.width, this.canvasElement.nativeElement.height);
        }

        this.isCameraOn = false;
        this.faces = [];
        this.faceCount = 0;
        this.trackMemory = [];
        this.lastLogKey = "";
        this.statusMessage = "웹캠을 시작하세요.";
        await this.service.render();
    }

    public async openExperimentPopup() {
        this.isExperimentPopupOpen = true;
        await this.service.render();
    }

    public async closeExperimentPopup() {
        this.isExperimentPopupOpen = false;
        await this.service.render();
    }

    private startAnalysis() {
        if (this.captureInterval) clearInterval(this.captureInterval);
        const intervalMs = 333;
        this.captureInterval = setInterval(() => {
            this.captureAndPredict();
        }, intervalMs);
    }

    private async captureAndPredict() {
        const video = this.videoElement.nativeElement;
        if (!video || video.videoWidth === 0 || video.videoHeight === 0) return;

        const canvas = document.createElement('canvas');
        canvas.width = video.videoWidth;
        canvas.height = video.videoHeight;
        const ctx = canvas.getContext('2d');
        if (!ctx) return;
        ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
        const dataUrl = canvas.toDataURL('image/jpeg', 0.82);

        try {
            const resultInfo = await wiz.call("predict", {
                image: dataUrl,
                tracks: JSON.stringify(this.trackMemory)
            });

            if (resultInfo.code === 200 && resultInfo.data.status === "success") {
                const result = resultInfo.data;
                this.meta = result.meta;
                this.faces = result.faces || [];
                this.faceCount = result.face_count || 0;
                this.inferMs = result.infer_ms || 0;
                this.trackMemory = result.tracks || [];
                this.statusMessage = this.faceCount > 0 ? `${this.faceCount}명 얼굴 분석 중` : "얼굴 미검출";
                this.addLog();
                this.drawOverlay(this.faces, result.frame);
            } else {
                this.faces = [];
                this.faceCount = 0;
                this.statusMessage = resultInfo.data.message || "분석 실패";
                this.drawOverlay([], null);
            }
        } catch (e) {
            console.error("Predict Exception:", e);
            this.statusMessage = "분석 호출 실패";
        }
        await this.service.render();
    }

    private addLog() {
        const now = new Date();
        const time = now.toLocaleTimeString();
        const logKey = this.buildLogKey();
        if (logKey === this.lastLogKey) return;

        const summary = this.faces.map(face => `#${face.track_id} ${face.expression} ${this.fmtPct(face.confidence)}`).join(", ");
        this.eventLog.unshift({
            time,
            count: this.faceCount,
            summary: summary || "-",
            inferMs: this.inferMs
        });
        this.lastLogKey = logKey;
        if (this.eventLog.length > 40) this.eventLog.pop();
    }

    private buildLogKey() {
        const faceState = this.faces
            .map(face => `#${face.track_id}:${face.expression}`)
            .sort()
            .join("|");
        return `${this.faceCount}:${faceState}`;
    }

    private syncCanvasSize() {
        const canvas = this.canvasElement.nativeElement;
        const video = this.videoElement.nativeElement;
        if (canvas.width !== video.clientWidth || canvas.height !== video.clientHeight) {
            canvas.width = video.clientWidth;
            canvas.height = video.clientHeight;
        }
    }

    private drawOverlay(faces: any[], frame: any) {
        const canvas = this.canvasElement.nativeElement;
        const video = this.videoElement.nativeElement;
        const ctx = canvas.getContext('2d');
        if (!ctx) return;
        this.syncCanvasSize();
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        if (!faces || !frame) return;

        const frameW = frame.width || video.videoWidth;
        const frameH = frame.height || video.videoHeight;
        const videoRatio = frameW / frameH;
        const containerRatio = canvas.width / canvas.height;
        let drawWidth = 0;
        let drawHeight = 0;
        let offsetX = 0;
        let offsetY = 0;

        if (containerRatio > videoRatio) {
            drawWidth = canvas.width;
            drawHeight = canvas.width / videoRatio;
            offsetY = (canvas.height - drawHeight) / 2;
        } else {
            drawHeight = canvas.height;
            drawWidth = canvas.height * videoRatio;
            offsetX = (canvas.width - drawWidth) / 2;
        }

        const scaleX = drawWidth / frameW;
        const scaleY = drawHeight / frameH;
        faces.forEach((face) => {
            const region = face.bbox;
            const x = region.x * scaleX + offsetX;
            const y = region.y * scaleY + offsetY;
            const w = region.w * scaleX;
            const h = region.h * scaleY;
            const uncertain = face.expression === "uncertain";
            const color = uncertain ? "#f59e0b" : "#10b981";
            const label = `#${face.track_id} ${face.expression} ${this.fmtPct(face.confidence)}`;
            const labelWidth = Math.min(Math.max(ctx.measureText(label).width + 18, 140), Math.max(160, w + 16));

            ctx.strokeStyle = color;
            ctx.lineWidth = 3;
            ctx.strokeRect(x, y, w, h);
            ctx.fillStyle = color;
            ctx.fillRect(x, Math.max(0, y - 30), labelWidth, 28);
            ctx.fillStyle = "#ffffff";
            ctx.font = "bold 13px sans-serif";
            ctx.fillText(label, x + 8, Math.max(19, y - 11));
        });
    }

    public fmt(value: any, digits: number = 2) {
        if (value === null || value === undefined || isNaN(value)) return "-";
        return Number(value).toFixed(digits);
    }

    public fmtPct(value: any) {
        if (value === null || value === undefined || isNaN(value)) return "-";
        return `${Math.round(Number(value) * 100)}%`;
    }

    public topExpressions(face: any) {
        if (!face || !face.expression_probs) return [];
        return Object.keys(face.expression_probs)
            .map(key => ({ label: key, value: face.expression_probs[key] }))
            .sort((a, b) => b.value - a.value)
            .slice(0, 3);
    }
}

export default PagePrototype4Component;